import React, { useCallback, useEffect, useState, useRef } from 'react';
import SearchIcon from '@assets/icons/search-icon.svg';
import ResetFilterIcon from '@assets/icons/reset-filter-icon.svg';
import {
	SmartDivider, SmartTaskCount,
	SmartToolbarContainerFull,
	SmartToolbarGroupCenter,
	SmartToolbarGroupLeft, SmartToolbarGroupRight
} from '~/FielderElements/SmartTaskTable/SmartStyles';
import { Box, FormControl, IconButton, InputAdornment, MenuItem, Select, TextField, Tooltip } from '@mui/material';
import { MRT_ShowHideColumnsButton, MRT_ToggleFiltersButton, MRT_ToggleFullScreenButton } from 'material-react-table';
import Button from '@mui/material/Button';
import { DropdownDatesFilter, RangeDatePicker } from '~/FielderElements/SmartTaskTable/filters';
import { isEqual } from 'date-fns';
import DatesFilterUtil from 'OldComponents/Analitics/DatesFilterUtil';

const SmartRouteAuxToolbar = (
	{
		lan,
		totalNumberOfElements,
		titleElement,
		showCheckboxComponent,
		auxToolbarActions,
		table,
		onDateRangeChange,
		onDatesDropdownApply,
		dateRange: dateRangeProp = [null, null],
		datesDropdownValues: datesDropdownProp = [DatesFilterUtil.EXECUTION_PERIOD_TIME, DatesFilterUtil.EXECUTION_DATE],
		showFilter,
		handleFilter,
		handleDeleteFilter,
		handlerEventKey,
		handleResetFilter,
		filter,
	}) => {
	const [dateRange, setDateRange] = useState(dateRangeProp);
	const [datesDropdown, setDatesDropdown] = useState(datesDropdownProp);
	const [clearAdvancedFilterSignal, setClearAdvancedFilterSignal] = useState(0);
	const prevDateRangeRef = useRef(dateRangeProp);
	const updateDateRange = useCallback((updater) => {
		setDateRange((prev) => {
			const next = typeof updater === 'function' ? updater(prev) : updater;
			const sameStart = prev[0] === next[0] || (prev[0] && next[0] && isEqual(prev[0], next[0]));
			const sameEnd = prev[1] === next[1] || (prev[1] && next[1] && isEqual(prev[1], next[1]));
			if (sameStart && sameEnd) return prev;
			return next;
		});
	}, []);
	useEffect(() => {
		if (!onDateRangeChange) return;
		const prev = prevDateRangeRef.current;
		const changed =
			!prev ||
			!(prev[0] === dateRange[0] || (prev[0] && dateRange[0] && isEqual(prev[0], dateRange[0]))) ||
			!(prev[1] === dateRange[1] || (prev[1] && dateRange[1] && isEqual(prev[1], dateRange[1])));
		if (!changed) return;
		prevDateRangeRef.current = dateRange;
		if (!dateRange[0] && !dateRange[1]) {
			setDatesDropdown(datesDropdownProp);
			onDateRangeChange([null, null]);
			setClearAdvancedFilterSignal((s) => s + 1);
		} else if (dateRange[0] && dateRange[1]) {
			onDateRangeChange(dateRange);
		}
	}, [dateRange, onDateRangeChange, datesDropdownProp]);
	const handleDatesDropdownApply = useCallback(() => {
		if (onDatesDropdownApply) onDatesDropdownApply(datesDropdown);
	}, [datesDropdown, onDatesDropdownApply]);
	return (
		<Box sx={SmartToolbarContainerFull}>
			<Box sx={SmartToolbarGroupLeft}>
				{showCheckboxComponent && (auxToolbarActions)}
			</Box>
			<Box sx={SmartToolbarGroupCenter}>
				<MRT_ToggleFiltersButton table={table} />
				<RangeDatePicker
					startDate={dateRange[0]}
					endDate={dateRange[1]}
					handleFromDateFromForm={(date) =>
						updateDateRange(([_, end]) => [date, end])
					}
					handleToDateFromForm={(date) =>
						updateDateRange(([start]) => [start, date])
					}
				/>
				<DropdownDatesFilter
					showApplyButton
					disabled={!dateRange[1]}
					onChangeValues={setDatesDropdown}
					executeFilters={handleDatesDropdownApply}
					values={datesDropdown}
				/>
				{showFilter && (
					<TextField
						id='tf-filter'
						size='small'
						value={filter || ''}
						onChange={(e) => handleDeleteFilter(e.target.value)}
						onKeyDown={handlerEventKey}
						slotProps={{
							input: {
								endAdornment: (
									<InputAdornment position='end'>
										{filter != null && (
											<IconButton size='small' onClick={handleResetFilter}>
												<img src={ResetFilterIcon} className='icon cursor-pointer' alt='' />
											</IconButton>
										)}
										<IconButton size='small' onClick={handleFilter}>
											<img src={SearchIcon} className='icon cursor-pointer' alt='' />
										</IconButton>
									</InputAdornment>
								)
							}
						}}
					/>
				)}
			</Box>
			<Box sx={SmartToolbarGroupRight}>
				<MRT_ShowHideColumnsButton table={table} />
				<MRT_ToggleFullScreenButton table={table} />
				<SmartDivider orientation="vertical" variant="middle" flexItem />
				<Button
					size="large"
					loading={false}
					disabled={false}
					style={{ color: '#dc5c87' }}>
					<SmartTaskCount variant={'h5'}>{totalNumberOfElements} {titleElement}</SmartTaskCount>
				</Button>
			</Box>
		</Box>
	)
};
export default SmartRouteAuxToolbar;
